import { Link } from 'react-router-dom';
import { trpc } from '@/trpc/client';
import type { MessageKey } from '../../../../src/messages/types';
import { MESSAGE_DESCRIPTIONS, MESSAGE_KEY_ORDER } from './messageKeyMeta';

export function TemplatesList(): JSX.Element {
  const { data, isLoading } = trpc.templates.list.useQuery();
  if (isLoading) return <p>読み込み中...</p>;

  const orderIndex = new Map(MESSAGE_KEY_ORDER.map((k, i) => [k, i]));
  const sortedRows = [...(data ?? [])].sort(
    (a, b) =>
      (orderIndex.get(a.key as MessageKey) ?? 999) - (orderIndex.get(b.key as MessageKey) ?? 999),
  );

  return (
    <div>
      <h1 className="mb-4 text-lg font-semibold">テンプレート</h1>
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50 text-xs uppercase text-gray-600">
          <tr>
            <th className="px-3 py-2 text-left">key</th>
            <th className="px-3 py-2 text-left">説明</th>
            <th className="px-3 py-2 text-left">最終更新者</th>
            <th className="px-3 py-2 text-left">更新日時</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {sortedRows.map((row) => (
            <tr key={row.key} className="hover:bg-gray-50">
              <td className="px-3 py-2">
                <Link to={`/templates/${row.key}`} className="text-blue-700 hover:underline">
                  {row.key}
                </Link>
              </td>
              <td className="px-3 py-2 max-w-md text-sm text-gray-700">
                {MESSAGE_DESCRIPTIONS[row.key as MessageKey] ?? '—'}
              </td>
              <td className="px-3 py-2 text-sm">{row.updatedBy?.email ?? '—'}</td>
              <td className="px-3 py-2 text-xs text-gray-500">{row.updatedAt}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
